import { GET_VALUES, CLEAR_VALUES } from "../actions/type";
export default function exchange(state = {}, action) {
     
    switch (action.type) {
        case GET_VALUES:
            return { ...state, initialValues: action.data };
        case CLEAR_VALUES:
            return { ...state, initialValues: {} };
    }
    return state;
}
